/**
 * ResumeMetric - Notice Period Calculator
 * Calculates last working day and remaining working days.
 * @module tools/noticePeriodCalculator
 */

export function calculateNoticePeriod(startDateStr, noticeDays) {
    if (!startDateStr || !noticeDays || noticeDays <= 0) return null;

    const [y, m, d] = startDateStr.split('-').map(Number);
    if (!y || !m || !d) return null;

    const startDate = new Date(y, m - 1, d);
    const lastDay = new Date(startDate);
    lastDay.setDate(lastDay.getDate() + noticeDays - 1);

    // Count working days (Mon-Fri)
    let workingDays = 0;
    let calendarDays = 0;
    const current = new Date(startDate);
    while (current <= lastDay) {
        calendarDays++;
        const dow = current.getDay();
        if (dow !== 0 && dow !== 6) workingDays++;
        current.setDate(current.getDate() + 1);
    }

    // Days remaining from today
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let daysRemaining = 0;
    let workingDaysRemaining = 0;
    if (lastDay >= today) {
        const cursor = new Date(Math.max(today.getTime(), startDate.getTime()));
        while (cursor <= lastDay) {
            daysRemaining++;
            const dow = cursor.getDay();
            if (dow !== 0 && dow !== 6) workingDaysRemaining++;
            cursor.setDate(cursor.getDate() + 1);
        }
    }

    // Weeks and months breakdown
    const weeks = Math.floor(calendarDays / 7);
    const remainderDays = calendarDays % 7;

    return {
        startDate,
        lastWorkingDay: lastDay,
        calendarDays,
        workingDays,
        weeks,
        remainderDays,
        daysRemaining,
        workingDaysRemaining,
        isComplete: lastDay < today
    };
}
